import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Alert from 'components/ui/Alert';
import ToastStore from 'stores/ToastStore';

class AlertNotificator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enabled: false,
      level: '',
      title: '',
    };
  }

  componentDidMount() {
    ToastStore.addChangeListener(this.refresh);
  }

  componentWillUnmount() {
    ToastStore.removeChangeListener(this.refresh);
  }

  onDismiss = () => {
    this.setState({ enabled: false });
    ToastStore.removeLatestNotification();
    if (this.props.onDismiss) {
      this.props.onDismiss();
    }
  };

  refresh = () => {
    const notification = ToastStore.getLatestNotification();
    if (notification) {
      const { level, title } = notification;
      this.setState({
        level,
        title,
        enabled: true,
      });
    } else {
      this.setState({
        enabled: false,
      });
    }
  };

  render() {
    if (!this.state.enabled) {
      return null;
    }
    return (
      <Alert type={this.state.level} onClose={this.onDismiss}>
        {this.state.title}
      </Alert>
    );
  }
}

AlertNotificator.propTypes = {
  onDismiss: PropTypes.func,
};

AlertNotificator.defaultProps = {
  onDismiss: null,
};

export default AlertNotificator;
